import React from 'react';

// Simple, reusable Card with optional header/footer slots
export function Card({ className = '', children, ...props }) {
  return (
    <div
      className={`bg-background-elevated rounded-xl border border-border/60 shadow-sm hover:shadow-md transition-shadow duration-200 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className = '', title, subtitle, actions, children }) {
  return (
    <div className={`px-6 py-5 border-b border-border/50 flex items-center justify-between gap-4 ${className}`}>
      <div>
        {title && (
          <h3 className="text-base font-semibold text-foreground tracking-tight">{title}</h3>
        )}
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1.5">{subtitle}</p>
        )}
        {children}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function CardContent({ className = '', children }) {
  return <div className={`px-6 py-5 ${className}`}>{children}</div>;
}

export function CardFooter({ className = '', children }) {
  return <div className={`px-6 py-4 border-t border-border/50 ${className}`}>{children}</div>;
}

export default Card;
